// extracted by mini-css-extract-plugin
export default {"btnBox":"GameBtn_btnBox__075cj"};